import type { Module } from 'vuex';

export type ActiveImportJobItem = {
  id: string;
  catalogItemType?: string;
  status?: string;
  progress?: { done: number; total: number };
  finishedErrors?: { index: number; message: string }[];
  createdBy?: { firstName?: string; lastName?: string; code?: string; id?: string };
  createdAt?: { seconds?: number; nanoseconds?: number };
};

type CatalogItemImportState = {
  activeImportJobs: ActiveImportJobItem[];
};

const initial = (): CatalogItemImportState => ({
  activeImportJobs: [],
});

function normType(t: unknown) {
  return String(t ?? '')
    .trim()
    .toLowerCase();
}

function createdAtKey(j: ActiveImportJobItem): [number, number] {
  const t = j.createdAt;
  if (t && typeof t === 'object' && t !== null) {
    const s = (t as { seconds?: number }).seconds;
    const n = (t as { nanoseconds?: number }).nanoseconds;
    if (s != null) return [s, n != null && Number.isFinite(n) ? n : 0];
  }
  return [0, 0];
}

function isActiveStatus(st: unknown) {
  return st === 'queued' || st === 'processing';
}

const storeModule: Module<CatalogItemImportState, unknown> = {
  namespaced: true,
  state: initial(),
  mutations: {
    setActiveImportJobs(s, list) {
      s.activeImportJobs = Array.isArray(list) ? (list as ActiveImportJobItem[]) : [];
    },
  },
  getters: {
    activeJobByType: s => (t: string) => {
      const w = normType(t);
      const matches = s.activeImportJobs.filter(j => {
        if (!j) return false;
        if (!isActiveStatus(j.status)) return false;
        return normType(j.catalogItemType) === w;
      });
      if (!matches.length) return undefined;
      return matches.reduce((a, b) => {
        const [as, an] = createdAtKey(a);
        const [bs, bn] = createdAtKey(b);
        if (bs > as) return b;
        if (bs < as) return a;
        return bn > an ? b : a;
      });
    },
  },
};

export default storeModule;
